import React from "react";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import "tippy.js/animations/scale.css"; // Import the desired animation
import utils from "../../helpers/utils";
import ImageTooltipContent from "./ImageTooltipContent";
import PropTypes from "prop-types";

const TooltipImage = (props) => {


    return (
        <>
            <Tippy
                animation={"scale"}
                duration={[300, 250]}
                content={
                    <ImageTooltipContent
                        filePath={utils.defaultUrl() + props.filePath}
                        fileName={props.fileName}/>
                }
                interactive={true}
                placement="bottom">

                <div className={"cursor-pointer d-inline-block " + props.className}
                     onClick={e => utils.openFile(props.filePath)}>

                    {props.children}
                </div>
            </Tippy>
        </>
    );
};

TooltipImage.propTypes = {
    filePath: PropTypes.string.isRequired,
    fileName: PropTypes.string.isRequired,
    className: PropTypes.string,
    children: PropTypes.node
};

export default TooltipImage;